import React from "react";
import {Card, CardContent, Grid, Typography} from "@mui/material";
import {sprintf} from "sprintf-js";
import {ChecklistField} from "../formFields/ChecklistField";
import ChecklistItemDefault from "../defaults/ChecklistItemDefault";

const [section, name, title] = [7, "HeatingAndPlumbing", "Heating & Plumbing"];

const HeatingAndPlumbingDefaults = () => {
    return {
        "7": {
            "1": ChecklistItemDefault,
            "2": ChecklistItemDefault,
            "3": ChecklistItemDefault,
            "4": ChecklistItemDefault,
            "5": ChecklistItemDefault,
            "6": ChecklistItemDefault,
            "7": ChecklistItemDefault
        }
    };
}

const HeatingAndPlumbing = () => {
    const relPath = name;
    return (
        <>
            <Card>
                <CardContent>
                    <Typography variant={"h6"} gutterBottom>
                        {sprintf("%d. %s", section, title)}
                    </Typography>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "heatingAdequacy")}
                            rank={"7.1"}
                            room={name}
                            desc={"Adequacy of Heating Equipment"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "heatingSafety")}
                            rank={"7.2"}
                            room={name}
                            desc={"Safety of Heating Equipment"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "ventilationCooling")}
                            rank={"7.3"}
                            room={name}
                            desc={"Ventilation / Cooling"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "waterHeater")}
                            rank={"7.4"}
                            room={name}
                            desc={"Water Heater"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "waterSupply")}
                            rank={"7.5"}
                            room={name}
                            desc={"Approvable Water Supply"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "plumbing")}
                            rank={"7.6"}
                            room={name}
                            desc={"Plumbing"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "sewer")}
                            rank={"7.7"}
                            room={name}
                            desc={"Sewer Connections"}
                            section={section}
                        />
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
};

export default HeatingAndPlumbing;
export {HeatingAndPlumbingDefaults};